module.exports = __webpack_public_path__ + "img/high-school-parent-course.7d41cb26.png";